import React, { useState } from "react";
import PropTypes from "prop-types";
import GlobalOverlay from "../globalOverlay/globalOverlay";
import styles from "./learnMore.module.css";
import ReactTooltip from "react-tooltip";
import { InfoIcon } from "../../../assets/images/svg";

export default function LearnMore(props) {
  const [isVisible, setIsVisible] = useState(false);
  const {
    title,
    content,
    customStyles = {},
    html,
    link,
    direction = "right",
    additionalInfo = false,
    testId = "learnMoreButton"
  } = props;
  const handleLearnMore = () => {
    setIsVisible(!isVisible);
  };
  const openLink = () => {
    window.open(link, "_blank", "noopener noreferrer");
  };

  function returnMarkup() {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
  }

  return (
    <>
      <GlobalOverlay isVisible={isVisible} onClick={handleLearnMore} />
      <div
        className={`${styles.reactLearnMore} ${isVisible ? styles.active : ""}`}
        data-testid={testId}
      >
        <button
          className={`${styles.reactLearnMore__button}`}
          data-tip={link ? content : undefined}
          data-for={`${title} tooltip`}
          onClick={link ? openLink : handleLearnMore}
        >
          {!additionalInfo ? (
            <InfoIcon className="infoIcon" />
          ) : (
            <span
              className={`${styles.tags_icon} glyphicon glyphicon-tags`}
              style={{ paddingTop: "1px" }}
            ></span>
          )}
        </button>

        {isVisible && (
          <div className={`${styles.overlay}`} style={{ ...customStyles }}>
            {title && <h2>{title}</h2>}
            {content && html ? returnMarkup() : content}
          </div>
        )}
        {link && (
          <ReactTooltip
            className={`${styles.learnMore_tooltip}`}
            id={`${title} tooltip`}
            place={direction}
            effect="solid"
            html
          />
        )}
      </div>
    </>
  );
}

LearnMore.propTypes = {
  title: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  customStyles: PropTypes.object,
  html: PropTypes.bool,
  link: PropTypes.string,
  direction: PropTypes.oneOf(["top", "bottom", "left", "right"])
};
